import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { WhatsAppConversation } from "../../aiConversations.types";
import { requestMarkReadConversation } from "./markReadConversation.request";

const useMarkReadConversation = (
  options?: MutationOptions<
    WhatsAppConversation,
    ApiServiceError<ApiError>,
    string
  >
) => {
  return useMutation({
    mutationFn: requestMarkReadConversation,
    ...options
  });
};

export default useMarkReadConversation;
